@if(isArray()) {
<ng-container *ngTemplateOutlet="viewList"></ng-container>
}@else {
<ng-container *ngTemplateOutlet="viewError; context: { keyService }"></ng-container>
}

<!-- View List -->
<ng-template #viewList>
  <div class="rh-action-buttons">
    <button mat-button (click)="accordion().openAll()">Expand All</button>
    <button mat-button (click)="accordion().closeAll()">Collapse All</button>
  </div>
  <mat-accordion class="rh-headers-align" multi>
    <mat-grid-list cols="2" rowHeight="55px">
      @for(data of listKeys$; track $index) {
      <mat-grid-tile [rowspan]="isExpanded($index) ? 9 : 1">
        <mat-expansion-panel [@.disabled]="true" [style.width]="'98%'" (opened)="onPanelOpen($index)"
          (closed)="onPanelClose($index)">
          <mat-expansion-panel-header>
            <mat-panel-title>Key Name:
              <span [style.marginLeft]="'0.5rem'" [style.color]="'var(--sys-primary)'" class="mat-label-large">
                {{ data.name }}
              </span></mat-panel-title>
            <mat-panel-description>
              <strong [style.fontWeight]="'var(--mat-expansion-header-text-weight)'"
                [style.color]="'var(--mat-expansion-header-text-color)'">Expires:
                <span [style.marginLeft]="'0.5rem'" [style.color]="'var(--sys-primary)'" class="mat-label-large">
                  @if (data.expires_at === null || data.expires_at === undefined) { Never } @else { {{ data.expires_at |
                  date }} }
                </span></strong>
              @if(isExpired(data.expires_at)) {
              <mat-icon [style.color]="'#ba1a1a'">error</mat-icon>
              } @if(isExpiring(data.expires_at)) {
              <mat-icon [style.color]="'#ff7f00'">warning</mat-icon>
              }
              <button mat-button (click)="$event.stopPropagation()" (click)="openDialog(data)"
                matTooltip="Change Expiration" matTooltipPosition="above">
                <mat-icon>edit</mat-icon>
              </button>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <mat-form-field>
            <mat-label>Key Info Response</mat-label>
            <textarea matInput readonly cols="100" rows="15" [style.resize]="'none'">{{
              convertData(data)
            }}</textarea>
          </mat-form-field>
        </mat-expansion-panel>
      </mat-grid-tile>
      }
    </mat-grid-list>
  </mat-accordion>
</ng-template>

<!-- View Error -->
<ng-template #viewError let-keyService="keyService">
  <mat-grid-list cols="1" rowHeight="100px">
    <mat-grid-tile rowspan="3">
      <mat-form-field>
        <mat-label>Key Info Error Response</mat-label>
        <textarea matInput readonly cols="100" rows="10" [style.resize]="'none'">{{
          convertError(keyService.listKeysResponse())
        }}</textarea>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
</ng-template>